import { Theme, makeStyles } from '@forgeglobal/design-framework';

type CSSProps = {
  footerHeight?: number;
};

const useStyles = makeStyles((theme: Theme) => ({
  arrowContainer: {
    position: 'absolute',
    top: 100,
    left: theme.spacing(4),
    zIndex: 1000,
    [theme.breakpoints.down('sm')]: {
      top: 80,
      left: theme.spacing(3),
      backgroundColor: '#fff',
      borderRadius: '50%',
      padding: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
    },
  },
  arrow: {
    display: 'flex',
    cursor: 'pointer',
  },
  content: {
    padding: '0 !Important',
    backgroundColor: theme.palette.background.paper,
  },
  mainWrapper: {
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    backgroundColor: theme.palette.background.paper,
  },
  innerContent: {
    padding: theme.spacing(4, 3, 0),
  },
  footer: (prop: CSSProps) => ({
    borderTop: `1px solid ${theme.palette.divider}`,
    height: prop.footerHeight ?? 68,
  }),
  dialogBody: {
    maxWidth: 480,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 4),
    },
  },
  messageBody: {
    maxWidth: 640,
    width: '100%',
  },
  messageContainer: {
    alignItems: 'center',
    minHeight: '80vh',
    textAlign: 'center',
  },
}));

export default useStyles;
